require.register("local-data/assessments/phd-qafeedback-CO", function(exports, require, module){
  module.exports = {
  "seed": "2a294251-217c-4ca7-87fe-ef78cac7fa0b",
  "questions": [
    {
      "id": 1,
      "text": "JAY - People always know when they’re making decisions that are based on unfair assumptions or stereotypes.",
      "correct_answer": "B",
      "answers": [
        {
          "id": "A",
          "text": "True",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "False",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 2,
      "text": "Not watching cable news or reading social media means your beliefs and biases won’t be shaped by the media.",
      "correct_answer": "B",
      "answers": [
        {
          "id": "A",
          "text": "True",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "False",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 3,
      "text": "What should Fahad do?",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "Say to Debbie, “Honestly, this makes me nervous, and a little frustrated—I thought we agreed on a deadline. I really want us to shine tomorrow. How can we move forward from here?”",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Say to Debbie, “You’re going to make me look so bad! This is really irresponsible and selfish.”",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "C",
          "text": "Bottle up his frustration and simply ask Debbie “They’ll be done by tomorrow, right?”",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 4,
      "text": "Which of the following is not problematic behavior?",
      "correct_answer": "C",
      "answers": [
        {
          "id": "A",
          "text": "Shouting, because it shows engagement.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Dave explains that his age and background make his perspective the most important.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "C",
          "text": "The fact that they are strongly disagreeing.",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 5,
      "text": "What’s Guzman’s best path forward?",
      "correct_answer": "B",
      "answers": [
        {
          "id": "A",
          "text": "Say, “Please stop checking your phone—that’s rude.”",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Ask, “Is everything OK, Sam? Is this still a good time to meet?”",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        },
        {
          "id": "C",
          "text": "Pull out his phone while Sam is talking so Sam understands how it feels. ",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 6,
      "text": "Is this a warning sign?",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "Yes",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "No",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 7,
      "text": "Is this a warning sign?",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "Yes",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "No",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 8,
      "text": "Is this a warning sign?",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "Yes",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "No",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 9,
      "text": "Is this possible discrimination?",
      "correct_answer": "B",
      "answers": [
        {
          "id": "A",
          "text": "Yes",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "No",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 10,
      "text": "Is there a problem with Farah's interview strategy? ",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "Yes",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "No",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 11,
      "text": "Should you do something?",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "Probably not. Dennis’s behavior seems reasonable.",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Yes. If something different is happening to the only man in the group, it’s always an issue.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 12,
      "text": "Which of the following does not seem like a good strategy to use when writing inclusive job descriptions?",
      "correct_answer": "B",
      "answers": [
        {
          "id": "A",
          "text": "Use software such as a bias decoder to check the description for words that discourage qualified people from certain groups from applying.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "List out plenty of job requirements, even if they’re not all necessary for the listed job. This helps more people feel included by the description.",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        },
        {
          "id": "C",
          "text": "Include a wide range of employment benefits, such as paid sick days, parental leave, healthcare options, or the process your organization uses for requesting workplace accommodations.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 13,
      "text": "Which of the following is a good strategy for removing bias from performance reviews?",
      "correct_answer": "D",
      "answers": [
        {
          "id": "A",
          "text": "Evaluate employees using consistent, objective, job-related criteria.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Ensure that specific examples are included to support your evaluation/feedback in each area.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "C",
          "text": "Collect performance data and examples throughout the entire evaluation period instead of just reflecting at the end.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "D",
          "text": "All of the above.",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 14,
      "text": "What’s the most helpful thing you can say?",
      "correct_answer": "C",
      "answers": [
        {
          "id": "A",
          "text": "Tell her you’re proud of her. Make sure she knows how much you value her skills and that you believe in her. ",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Check in with her department head and put in a good word about her time as an intern.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "C",
          "text": "Tell her you’d like to continue supporting her as a mentor, if she’d like. If your company has a mentoring program, offer to help her enroll and let her know that she’s welcome to set up a time to chat with you.",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 15,
      "text": "How should you respond?",
      "correct_answer": "B",
      "answers": [
        {
          "id": "A",
          "text": "Excuse Marquis and move on.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Ask if Marquis may need a temporary schedule change during Ramadan.",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        },
        {
          "id": "C",
          "text": "Remind Marquis that it is his responsibility to show up to work on time every day.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 16,
      "text": "What should you say to Geoff?",
      "correct_answer": "C",
      "answers": [
        {
          "id": "A",
          "text": "Ask Geoff for detailed medical information. Is he on medications? Is he suicidal? You want to understand what you’re working with.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Tell Geoff that you'll need to get someone with expertise to deal with the issue.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "C",
          "text": "Ask Geoff to explain what’s been difficult about his ability to perform his job lately and  to share any ideas that he has for accommodations that might help.",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 17,
      "text": "What should you do?",
      "correct_answer": "B",
      "answers": [
        {
          "id": "A",
          "text": "Explain that Ash has an ADA accommodation, but do not share the diagnosis. You value Ash’s privacy, but don’t want Natasha to judge him unfairly.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Explain to Natasha that Ash is working equal hours on a slightly different schedule, and ask if there’s anything you can do to support her workload.",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        },
        {
          "id": "C",
          "text": "Pull Natasha aside and explain the details of Ash’s diagnosis in private. You don’t want Natasha to judge Ash unfairly, but it’s important that she knows why his schedule is different.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 18,
      "text": "What should you do?",
      "correct_answer": "B",
      "answers": [
        {
          "id": "A",
          "text": "Move on. If he hasn’t expressed a need to you, there’s nothing you can do.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Tell Ahanu that if he’s interested, you can work with him on any accommodations, like purchasing a device to make typing more comfortable.",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 19,
      "text": "What’s the best way to start the discussion?",
      "correct_answer": "C",
      "answers": [
        {
          "id": "A",
          "text": "Krishna, I really need you to try harder. I know you are capable of the work, but your effort on these past few projects has really been below what I know you can do.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Krishna, I wanted to see if there’s anything you need from me to help you excel at your job. I want to make sure I’m supporting you as well as I can.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "C",
          "text": "Krishna, you were doing great a few months ago, and I know you’re capable of this job. But lately, your performance has been suffering — what’s going on? ",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 20,
      "text": "What should you do? ",
      "correct_answer": "B",
      "answers": [
        {
          "id": "A",
          "text": "Take a cue from Weinan and the people around you. They must know something you don’t, and that’s why they aren’t intervening . . . maybe it’s an inside joke you haven’t heard yet.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Say something. Mocking an accent is offensive. It might be hurtful to other people within earshot, or even Weinan.",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 21,
      "text": "What should you do? ",
      "correct_answer": "B",
      "answers": [
        {
          "id": "A",
          "text": "Say nothing. Jessica is giving Kim a compliment, and besides, Kim smiled.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Intervene. Kim might have felt uncomfortable about Jessica making comments about her race, her husband’s appearance, or the prospect of having children.",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 22,
      "text": "What should you do? ",
      "correct_answer": "B",
      "answers": [
        {
          "id": "A",
          "text": "Leave it be. David is acting in Phil’s best interest, and besides, Phil won’t be hurt if he doesn’t know about the event.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Intervene. David is making a negative assumption about Phil based on his national origin.",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 23,
      "text": "What should she do? ",
      "correct_answer": "B",
      "answers": [
        {
          "id": "A",
          "text": "Ignore it. Priti doesn’t know how her mentor will interpret her intervention. Will she be seen as a troublemaker or embarrass herself? Better to leave it to other people who have been there longer.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Say something. Maybe it’ll be uncomfortable, but it’s the right thing to do—and wouldn’t any reasonable mentor be supportive?",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 24,
      "text": "What should you do? ",
      "correct_answer": "B",
      "answers": [
        {
          "id": "A",
          "text": "Wait for Lucy to respond. You were kind of wondering, too!",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Intervene. Those questions are a little invasive!",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 25,
      "text": "Would you say you feel more motivated to intervene when you see a problem unfolding?",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "Yes",
          "correct": true
        },
        {
          "id": "A",
          "text": "No",
          "correct": true
        }
      ]
    },
    {
      "id": 26,
      "text": "What should you do first?",
      "correct_answer": "B",
      "answers": [
        {
          "id": "A",
          "text": "Explain to Stacy that you know Brent well, and he’s harmless. She’ll probably be relieved to know she was misinterpreting it.",
          "correct": false,
          "feedback": {
            "region": "response",
            "Correct": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Tell Stacy that what she has just told you is very concerning—ogling is totally inappropriate at work. Then discuss her options for next steps.",
          "correct": true,
          "feedback": {
            "region": "response",
            "correct": {
              "blocks": [{
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 27,
      "text": "What should you do? ",
      "correct_answer": "B",
      "answers": [
        {
          "id": "A",
          "text": "Let Lee know that you’re confused, and ask him to re-tell what happened more slowly and in order. You can’t tell if you need to take action if you don’t know what happened.",
          "correct": false,
          "feedback": {
            "region": "response",
            "Correct": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Tell Lee you are concerned about what he’s telling you, and ask if he’d like to take a seat.",
          "correct": true,
          "feedback": {
            "region": "response",
            "correct": {
              "blocks": [{
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 28,
      "text": "What should you do? ",
      "correct_answer": "B",
      "answers": [
        {
          "id": "A",
          "text": "Nod along. You’ve never met this new employee, but she sounds obnoxious, and Mike is nice.",
          "correct": false,
          "feedback": {
            "region": "response",
            "Correct": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Tell Wei, “You know, I’ve never had a problem with Mike either, but we do need to take reports of harassment seriously. I know that you care a lot about being a leader who people can come to with challenges or concerns.”",
          "correct": true,
          "feedback": {
            "region": "response",
            "correct": {
              "blocks": [{
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 29,
      "text": "What should you do? ",
      "correct_answer": "B",
      "answers": [
        {
          "id": "A",
          "text": "Respond: “Yeah, Sean’s always trying to make a cheap joke. Ignoring him is probably best.” ",
          "correct": false,
          "feedback": {
            "region": "response",
            "Correct": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Respond: “I’m really sorry to hear about this. It’s clearly upsetting you.”",
          "correct": true,
          "feedback": {
            "region": "response",
            "correct": {
              "blocks": [{
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 30,
      "text": "Is this conclusion true or false?",
      "correct_answer": "B",
      "answers": [
        {
          "id": "A",
          "text": "True",
          "correct": false,
          "feedback": {
            "region": "response",
            "Correct": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "False",
          "correct": true,
          "feedback": {
            "region": "response",
            "correct": {
              "blocks": [{
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 31,
      "text": "Is this conclusion true or false?",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "True",
          "correct": true,
          "feedback": {
            "region": "response",
            "Correct": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "False",
          "correct": false,
          "feedback": {
            "region": "response",
            "correct": {
              "blocks": [{
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 32,
      "text": "Is this conclusion true or false?",
      "correct_answer": "B",
      "answers": [
        {
          "id": "A",
          "text": "True",
          "correct": false,
          "feedback": {
            "region": "response",
            "Correct": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "False",
          "correct": true,
          "feedback": {
            "region": "response",
            "correct": {
              "blocks": [{
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 33,
      "text": "How common are false accusations?",
      "correct_answer": "C",
      "answers": [
        {
          "id": "A",
          "text": "All the time. ",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Sometimes. ",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "C",
          "text": "Rarely. ",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 34,
      "text": "Is Louise experiencing illegal retaliation?",
      "correct_answer": "B",
      "answers": [
        {
          "id": "A",
          "text": "Yes. Rose treated Louise warmly until Rose complained. Then things went downhill. ",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "No. Rose’s behavior likely isn’t illegal retaliation--but she should’ve taken another approach.",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        },
        {
          "id": "C",
          "text": "Maybe, but only if Rose was specficially instructed not to treat Louise differently as a result of the investigation.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 35,
      "text": "Sofia is considering the following actions. Which would be the least effective?",
      "correct_answer": "C",
      "answers": [
        {
          "id": "A",
          "text": "Report to human resource professionals",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Report to James’s supervisor",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "C",
          "text": "Confront James about the transfer.",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 36,
      "text": "What should you do?",
      "correct_answer": "C",
      "answers": [
        {
          "id": "A",
          "text": "Nothing. You’re not positive you saw David rubbing Heidi’s back.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Tell David to stop sexually harassing Heidi.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "C",
          "text": "Take Heidi aside when David isn’t around, and ask if she feels uncomfortable with David’s behavior.",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 37,
      "text": "Which type of intervention would work best in this situation?",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "Politely say you don’t like that kind of joke and pass the phone back to Anna.",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Take Anna’s cell phone to human resource professionals to report the biased meme.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "C",
          "text": "Pretend to think the joke is funny just to be polite, but later check in with Don to make sure he wasn’t offended.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 38,
      "text": "How should Brad respond?",
      "correct_answer": "C",
      "answers": [
        {
          "id": "A",
          "text": "Sure, but I’m really in a time crunch now. Can you tell me quickly on the way to my meeting?",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Sure, but I’m really in a time crunch now. Can you send me an email about the issue instead?",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "C",
          "text": "Sure, but I’m really in a time crunch now. Can we meet in an hour, when I can devote my full attention to you?",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 39,
      "text": "What should you say to Henry?",
      "correct_answer": "C",
      "answers": [
        {
          "id": "A",
          "text": "That’s age discrimination! Come with me, I have to report this now.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Nothing. Henry is probably just nervous about presenting and meant no harm.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "C",
          "text": "Henry, that was not OK. Let’s talk after this meeting.",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 40,
      "text": "How should you respond?",
      "correct_answer": "B",
      "answers": [
        {
          "id": "A",
          "text": "“I’m sorry, but the meetings are mandatory. You’ll just have to learn how to handle Jules.”",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "“I’d like to learn more. What’s happening in these meetings?”",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 41,
      "text": "How should you respond?",
      "correct_answer": "B",
      "answers": [
        {
          "id": "A",
          "text": "I’m sorry, but the meetings are mandatory. You’ll just have to learn how to handle Jules.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "I’d like to learn more. What’s happening in these meetings?",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 42,
      "text": "How should you respond?",
      "correct_answer": "B",
      "answers": [
        {
          "id": "A",
          "text": "If that’s your preference, then that’s what we have to do.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Let me run this by our human resources department and let you know what they decide.",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 43,
      "text": "What should you do?",
      "correct_answer": "C",
      "answers": [
        {
          "id": "A",
          "text": "Since you don’t know for sure whether the incident occurred, you don’t have to report. But you should still try to convince Rohawna to let you report.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Agree to Rohawna's wishes and keep the matter confidential. It's enough that her concerns were heard and validated.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "C",
          "text": "Tell Rohawna that, while our policy requires us to handle her complaint fairly, you won’t share the information with anyone who doesn’t need to know. In the meantime, you can help her decide how to approach interactions with Jack.",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 44,
      "text": "How should you respond?",
      "correct_answer": "C",
      "answers": [
        {
          "id": "A",
          "text": "Assure Rohawna that you will talk to Jack and handle the situation.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Sympathize with her fears of retaliation and let Rohawna know that she's doing everyone a service by coming forward.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "C",
          "text": "Assure Rohawana that all reports are reviewed, and retaliation is prohibited. She should come forward if anyone tries to retaliate against her in any form, and you will be monitoring the situation. ",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 45,
      "text": "Is Iqra’s concern for Niamh warranted?",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "Yes, Iqra is right to be concerned.",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "No, Iqra is assuming too much and should not interfere.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "C",
          "text": "I’m not sure.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 46,
      "text": "Which of the following would be Iqra’s best response?",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "I noticed the cut on your lip last week, and that you’ve been off work more often than usual. You looked upset and worried after the conference call today. Is there anything I can do to help?",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "I’ve noticed that you’ve had trouble meeting your deadlines lately. Can we talk about how to manage your workload?",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "C",
          "text": "I am concerned about you. You seem isolated and afraid. Are you OK? Did Karl do that to your lip? Can I help?",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 47,
      "text": "What should be Iqra’s first response to Niamh’s disclosure?",
      "correct_answer": "C",
      "answers": [
        {
          "id": "A",
          "text": "What about your daughter, are you worried about her? Are you sure that she is safe?",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "No one deserves to be harassed by their partner. We can put you in touch with people who can help if you need that.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "C",
          "text": "What you’re sharing is really concerning to me, Niamh. Because of my role on campus, I do have reporting responsibilities, but I’m also here to help. If you would prefer to talk about your options with someone who can keep your experience confidential, I can connect you to them as well.",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "descrsiption": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 48,
      "text": "What advice would you give Dr. Lutz?",
      "correct_answer": "A",
      "answers": [
        {
          "id": "A",
          "text": "He should first address the incident by thanking Mei for sharing this, telling her that he wants to help, and offering to connect her with support and confidential resources that are available on-campus or in the community.  Dr. Lutz should also follow any other reporting or response procedures set forth by his institution.",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "He should not respond to Mei, but address the incident she mentions with the institution.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "C",
          "text": "He should respond to the student but only address her academic question. Afterwards, he should report the incident to the institution's Title IX coordinator, but not inform Mei of that decision.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 49,
      "text": "Which of the following is the best reply? ",
      "correct_answer": "B",
      "answers": [
        {
          "id": "A",
          "text": "In order to respond to this situation appropriately, I would have to know more about what happened.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Confidential resources are available to explain your options, and if you decide to report the incident, the school’s Title IX Coordinator can provide supportive measures to you.",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        },
        {
          "id": "C",
          "text": "As you clearly did not intend to report this, I will forget we ever had this conversation.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 50,
      "text": "What else, if anything, should he add to his email?",
      "correct_answer": "C",
      "answers": [
        {
          "id": "A",
          "text": "Dr. Lutz should tell the Title IX coordinator both what happened and his impressions of the situation: Dear Hilo, This is Alan Lutz from the Anthropology Department. One of my students inadvertently told me about an unreported incident. Knowing this student, I think that she…",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Dr. Lutz should tell the Title IX coordinator that an incident occurred and provide Mei’s identity, even though she does not want to file a report and does not want her identity revealed.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "C",
          "text": "Dr. Lutz doesn’t need to add anything, unless required to do so under the school's policies.",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 51,
      "text": "Which of the following would be the most appropriate response?",
      "correct_answer": "B",
      "answers": [
        {
          "id": "A",
          "text": "Jeh is my colleague, and I don’t want to cross any lines into his personal life.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Jeh’s public display of stress may be indicative of a much deeper problem in his personal life. I should say something.",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        },
        {
          "id": "C",
          "text": "I’m not sure; there must be someone better equipped to talk to Jeh.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 52,
      "text": "Should you stop and say something?",
      "correct_answer": "B",
      "answers": [
        {
          "id": "A",
          "text": "I’m friends with Sonja and Slav, but we’re not that good friends.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Yes, I should check on them to make sure everything is OK.",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        },
        {
          "id": "C",
          "text": "I’m not sure; isn’t it intrusive to walk up to his car and interrupt them?",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        }
      ]
    },
    {
      "id": 53,
      "text": "You know you should work with her to revise your project deadlines, but should you ask her to elaborate on the Tinder date? ",
      "correct_answer": "B",
      "answers": [
        {
          "id": "A",
          "text": "Don’t even go there. Her relationship is her business, and if she wants to get help, she should probably seek out the Counseling Center on campus.",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        },
        {
          "id": "B",
          "text": "Yes, you should say something. It’s incredibly troubling that someone is interfering with her work life in a confrontational way. ",
          "correct": true,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "success feedback" }]
              }]
            }
          }
        },
        {
          "id": "C",
          "text": "I’m not sure. Didn’t she choose to go on a date with him?",
          "correct": false,
          "feedback": {
            "region": "response",
            "incorrect": {
              "blocks": [{
                "type": "text",
                "items": [{ "description": "failure feedback" }]
              }]
            }
          }
        }
      ]
    }
  ]
};

  
});

